import Contact from "../src/views/Contact";

export default Contact;
